module.exports = __webpack_public_path__ + "assets/img/Earlytrade-Website-w960.01c9a300.jpg";